import { Button, DraggableWindowHeader, TextInput } from "@hoylu/client-common";
import React from "react";
import { useDispatch } from "react-redux";
import * as workspacesActions from "../../state/workspaces/workspaces.actions";
import { useI18n } from "../../utils/hooks/use.i18n";
import Styles from "./ChangeMasterDialog.module.css";
import { Modal } from "./Modal";

export const ChangeMasterDialog = () => {
  const dispatch = useDispatch();

  const t = useI18n("CHANGE_MASTER_DIALOG.");
  const tClose = useI18n("CLOSE_BUTTON.");

  const changeMaster = () => {};

  const cancelDashboardOption = () =>
    dispatch(workspacesActions.cancelDashboardOption());

  return (
    <Modal allowContentToOverflow handleOutsideClick={cancelDashboardOption}>
      <div data-test-id="remove-template-dialog">
        <DraggableWindowHeader
          close={tClose("CLOSE")}
          onClose={cancelDashboardOption}
          title={t("TITLE")}
        />
        <div className={Styles.subtitle}>
          <span>{t("SUBTITLE")}</span>
          <TextInput
            inputStyle={{ paddingBottom: "4px" }}
            label=""
            style={{ width: "100%" }}
          />
        </div>
        <div className={Styles.buttons}>
          <Button
            dataTestId={t("CANCEL")}
            onClick={cancelDashboardOption}
            type="secondary"
          >
            {t("CANCEL")}
          </Button>
          <Button
            dataTestId="change-linked-master"
            onClick={changeMaster}
            type="primary"
          >
            {t("CHANGE_MASTER")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ChangeMasterDialog;
